/* Copied from https://github.com/clauderic/react-native-highlight-words */
import { FONT_FAMILY_BOLD, FONT_FAMILY_REGULAR } from '@unistocks/shared/consts';
import { findAll } from 'highlight-words-core';
import React from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import { useTheme } from 'tamagui';

export type HighLighterProps = {
  autoEscape?: boolean;
  highlightStyle?: TextProps['style'];
  searchWords: string[];
  textToHighlight: string;
  sanitize?: (text: string) => string;
  style?: TextProps['style'];
};

/**
 * Highlights all occurrences of search terms (searchText) within a string (textToHighlight).
 * This function returns an array of strings and <Text> elements (wrapping highlighted words).
 */
export const Highlighter: React.FC<HighLighterProps> = ({
  autoEscape,
  highlightStyle,
  searchWords,
  textToHighlight,
  sanitize,
  style,
  ...props
}) => {
  const chunks = findAll({ textToHighlight, searchWords, sanitize, autoEscape });
  const { bodyFont } = useTheme();

  return (
    <Text style={[styles.text, { color: bodyFont.get() }, style]} {...props}>
      {chunks.map((chunk, index) => {
        const text = textToHighlight.substring(chunk.start, chunk.end);

        return chunk.highlight ? (
          <Text
            key={index}
            style={[styles.textHighlight, { color: bodyFont.get() }, highlightStyle]}
          >
            {text}
          </Text>
        ) : (
          text
        );
      })}
    </Text>
  );
};

Highlighter.displayName = 'Highlighter';

const styles = StyleSheet.create({
  text: {
    fontFamily: FONT_FAMILY_REGULAR,
    fontWeight: 'normal',
    flexGrow: 1,
    flexShrink: 1
  },
  textHighlight: {
    fontFamily: FONT_FAMILY_BOLD
  }
});
